import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SostaOnlineApiService from '../services/SostaOnlineApiService'
import moment from 'moment'

moment.locale('it')


export default class BackOfficeUserDetailMarkLogsContainer extends Component {
  static propTypes = {
    markId: PropTypes.number
  }

  constructor (props) {
    super(props)
    this.state = {
      logs: [],
      loading: false
    }

    this.fetchLogs = this.fetchLogs.bind(this)
  }

  componentDidMount () {
    this.fetchLogs()
  }

  fetchLogs () {
    this.setState({loading: true})

    SostaOnlineApiService.fetchMarkLogs(this.props.markId).then((data) => {
      this.setState({
        logs: data.data,
        loading: false
      })
    })
  }

  widthDiv () {
    return '3500 pt'
  }

  render () {
    const {logs} = this.state
    return (
      <div style={{ padding: '0.1em', textAlign: 'left'}}>
        {logs.map((item, index) => {
          return (
            <div key={index}>
              <strong>{moment(item.createdAt).format('L LT')}</strong>{' '}<br />
              {item.Operator.firstName + ' ' + item.Operator.lastName}{' '}<br />
              <strong>{item.message}:</strong><br />
              <span>{item.description}</span><br />
              <hr style={{marginBottom: '5px', marginTop: '5px'}} />
            </div>
          )
        })}
      </div>
    )
  }
}


